const Data = [
  {
    name: "Sachin Maloo",
    position: "Finance Head",
    imageUrl: "/assets/images/members/GB26/Sachin.jpeg",
    facebookLink: "https://www.facebook.com/profile.php?id=100094359082523&mibextid=ZbWKwL",
    linkedinLink: "https://www.linkedin.com/in/sachin-gautam-chand-maloo-742aa1287/",
    email: "sachin.maloo@gyws.org"
  },
  {
    name: "Vislavath Rahul Sai",
    position: "Finance Head",
    imageUrl: "/assets/images/members/Heads25/RahulSai.JPG",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Akankshaa Padhi",
    position: "Finance Head",
    imageUrl: "/assets/images/members/Heads25/AkankshaaPadhi.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;